import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import FooterTwo from "../../component/footer/FooterTwo";

interface Props {}

class Go4network extends Component<Props>{
    render(): React.ReactNode{
        return(
            <React.Fragment>
                
                <PageHelmet pageTitle='Project Details' />

                <Header headertransparent="header--transparent" colorblack="color--white" logoname="logo.png" />

                <div className="rn-page-title-area pt--120 pb--190" style={{ backgroundImage: `url("/assets/images/banner-bg.jpg")` }}  >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-color ">Go4network</h2>
                                    <p>Mobile App</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        <div className="row sercice-details-content pb--80">
                                            <div className="col-lg-12 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/9.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                     
                                        <div className="row sercice-details-content pb--80">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h4 className="title">Go4Network</h4>
                                                    <p>I developed this Flutter-based app to help users monetize unused SMS and MMS quotas securely and discreetly. The app features:</p>
                                                    <p><strong>Stealth Mode:</strong> Operates without leaving traces on the user&apos;s device, ensuring complete privacy and anonymity during background operation.</p>
                                                    <p><strong>Dynamic Quota Management:</strong> Uses intelligent algorithms to optimize the sale of messages based on provider rates, real-time customer demand, and quota availability.</p>
                                                    <p><strong>Ease of Use:</strong> A simple &quot;Online&quot; toggle enables passive income generation with zero configuration required from the user.</p>
                                                    <p>By integrating Flutter for UI and Kotlin with Android&apos;s Messaging API, this project demonstrates my ability to create innovative, privacy-focused solutions that align user needs with market opportunities.</p>
                                                    <h4 className="title">My Working Process</h4>
                                                    <ul className="liststyle">
                                                        <li>Architecting a modular Flutter codebase with Provider state management</li>
                                                        <li>Implementing Android-native SMS/MMS interception via Kotlin and Telephony API</li>
                                                        <li>Building a secure backend API for message routing and quota tracking</li>
                                                        <li>Designing a stealth UI that operates invisibly on the device</li>
                                                        <li>Developing dynamic pricing algorithms for optimal quota monetization</li>
                                                        <li>Testing across multiple Android versions and carrier networks</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                     
                                        <h2 className="text-center mb--50">Project Screenshots</h2>

                                        <div className="row sercice-details-content align-items-center">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/1.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/2.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/4.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row sercice-details-content align-items-center mt--30">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/5.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/7.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4network/8.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                
                <FooterTwo />
            </React.Fragment>
        )
    }
}
export default Go4network;
